<!-- Modal Backdrop -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50" (click)="close()">
  <!-- Modal Box -->
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col m-4"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div class="flex items-center justify-between p-4 border-b border-base-300">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 flex items-center justify-center bg-warning/20 rounded-full">
          <i class="fa fa-clipboard-check text-warning"></i>
        </div>
        <div>
          <h2 class="text-lg font-bold">Lieferung freigeben</h2>
          <p class="text-sm text-base-content/60">Schritt {{ currentStep() }} von {{ totalSteps }}</p>
        </div>
      </div>
      <button class="btn btn-sm btn-ghost btn-circle" (click)="close()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Progress Steps -->
    <div class="px-4 py-3 border-b border-base-300 bg-base-200/50">
      <div class="flex items-center gap-2">
        <div class="flex items-center gap-2">
          <div
            class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium"
            [class.bg-primary]="currentStep() >= 1"
            [class.text-primary-content]="currentStep() >= 1"
            [class.bg-base-300]="currentStep() < 1"
          >1</div>
          <span class="text-sm font-medium" [class.text-primary]="currentStep() === 1">Stammdaten</span>
        </div>
        <div class="flex-1 h-0.5 bg-base-300 mx-2">
          <div class="h-full bg-primary transition-all" [style.width.%]="currentStep() >= 2 ? 100 : 0"></div>
        </div>
        <div class="flex items-center gap-2">
          <div
            class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium"
            [class.bg-primary]="currentStep() >= 2"
            [class.text-primary-content]="currentStep() >= 2"
            [class.bg-base-300]="currentStep() < 2"
          >2</div>
          <span class="text-sm font-medium" [class.text-primary]="currentStep() === 2">Artikelpositionen</span>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto p-4">
      <!-- Error Message -->
      @if (errorMessage()) {
        <div class="mb-4 p-3 bg-error/10 border border-error rounded-lg">
          <p class="text-error text-sm">{{ errorMessage() }}</p>
        </div>
      }

      <!-- Step 1: Stammdaten -->
      @if (currentStep() === 1) {
        <div class="space-y-6">
          <!-- PDF View Buttons -->
          @if (delivery.delivery_note_pdfs && delivery.delivery_note_pdfs.length > 0) {
            <div class="p-3 bg-base-200 border border-base-300 rounded-lg">
              <div class="flex items-center gap-2 mb-3">
                <i class="fa fa-file-pdf-o text-error text-xl"></i>
                <div>
                  <p class="font-medium text-sm">Lieferschein-Scans vorhanden ({{ delivery.delivery_note_pdfs.length }})</p>
                  <p class="text-xs text-base-content/60">Klicken Sie auf ein PDF um es zu öffnen</p>
                </div>
              </div>
              <div class="space-y-2">
                @for (pdf of delivery.delivery_note_pdfs; track pdf.filename; let i = $index) {
                  <div class="flex items-center justify-between p-2 bg-base-100 rounded border border-base-300">
                    <div class="flex items-center gap-2">
                      <i class="fa fa-file-pdf-o text-error"></i>
                      <div>
                        <span class="text-sm font-medium">PDF {{ i + 1 }}</span>
                        <span class="text-xs text-base-content/60 ml-2">{{ pdf.created_at | date:'dd.MM.yy HH:mm' }}</span>
                      </div>
                    </div>
                    <a
                      class="bm-btn bm-btn-xs bm-btn-primary"
                      [href]="getDeliveryNotePdfUrl(pdf.filename)"
                      target="_blank"
                    >
                      <i class="fa fa-external-link mr-1"></i>
                      Öffnen
                    </a>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Handlungsanweisung (Pflicht) -->
          <div class="p-4 bg-warning/10 border border-warning/30 rounded-lg">
            <label class="block text-sm font-semibold mb-2">
              Handlungsanweisung <span class="text-error">*</span>
            </label>
            <div class="flex gap-3">
              <select
                class="bm-select flex-1"
                [ngModel]="showCustomHandlingInstruction() ? 'OTHER' : handlingInstruction()"
                (ngModelChange)="onHandlingInstructionChange($event)"
              >
                <option value="">-- Bitte wählen --</option>
                @for (option of handlingInstructionOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
              @if (showCustomHandlingInstruction()) {
                <input
                  type="text"
                  class="bm-input flex-1"
                  placeholder="Freitext eingeben..."
                  [ngModel]="customHandlingInstruction()"
                  (ngModelChange)="onCustomHandlingInstructionChange($event)"
                />
              }
            </div>
          </div>

          <!-- Zuordnung -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Auftrags-Nr. (vom System vergeben, nicht editierbar) -->
            <div>
              <label class="block text-sm text-base-content/70 mb-1">Auftrags-Nr.</label>
              <input
                type="text"
                class="bm-input w-full"
                [ngModel]="orderNr()"
                disabled
              />
            </div>

            <!-- Ticket -->
            <div>
              <label class="block text-sm text-base-content/70 mb-1">Ticket</label>
              <div class="flex gap-2">
                <input
                  type="text"
                  class="bm-input flex-1"
                  placeholder="Ticket-Nr. eingeben"
                  [ngModel]="ticketNumber()"
                  (ngModelChange)="ticketNumber.set($event)"
                />
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="checkTicket()"
                  [disabled]="!ticketNumber() || ticketCheckStatus() === 'checking'"
                >
                  @if (ticketCheckStatus() === 'checking') {
                    <span class="loading loading-spinner loading-xs"></span>
                  } @else {
                    <i class="fa fa-search"></i>
                  }
                </button>
                @if (foundTicketId()) {
                  <button type="button" class="btn btn-ghost btn-sm text-error" (click)="clearTicket()">
                    <i class="fa fa-times"></i>
                  </button>
                }
              </div>
              @if (ticketCheckStatus() === 'found') {
                <p class="text-xs text-success mt-1">
                  <i class="fa fa-check mr-1"></i> Ticket gefunden (ID: {{ foundTicketId() }})
                </p>
              }
              @if (ticketCheckStatus() === 'not_found') {
                <p class="text-xs text-error mt-1">
                  <i class="fa fa-times mr-1"></i> Ticket nicht gefunden
                </p>
              }
            </div>

            <!-- Projekt -->
            <div>
              <label class="block text-sm text-base-content/70 mb-1">Projekt</label>
              <select
                class="bm-select w-full"
                [ngModel]="projectId()"
                (ngModelChange)="onProjectChange($event)"
              >
                <option [ngValue]="null">-- Kein Projekt --</option>
                @for (project of projects; track project.id) {
                  <option [ngValue]="project.id">{{ project.name }}</option>
                }
              </select>
            </div>

            <!-- Kunde -->
            <div>
              <label class="block text-sm text-base-content/70 mb-1">Kunde</label>
              <select
                class="bm-select w-full"
                [ngModel]="customerId()"
                (ngModelChange)="onCustomerChange($event)"
              >
                <option [ngValue]="null">-- Kein Kunde --</option>
                @for (customer of customers; track customer.id) {
                  <option [ngValue]="customer.id">{{ customer.name }}</option>
                }
              </select>
            </div>
          </div>

          <!-- Benachrichtigungen -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm text-base-content/70 mb-1">
                Interne Benachrichtigung
                <button
                  type="button"
                  class="ml-2 text-xs text-primary hover:underline"
                  (click)="openAdminUserModal()"
                >
                  (Benutzer auswählen)
                </button>
              </label>
              <input
                type="text"
                class="bm-input w-full"
                placeholder="E-Mail-Adressen (;-getrennt)"
                [ngModel]="internalNotificationEmails()"
                (ngModelChange)="internalNotificationEmails.set($event)"
              />
            </div>
            <div>
              <label class="block text-sm text-base-content/70 mb-1">Externe Benachrichtigung</label>
              <input
                type="text"
                class="bm-input w-full"
                placeholder="E-Mail-Adressen (;-getrennt)"
                [ngModel]="externalNotificationEmails()"
                (ngModelChange)="externalNotificationEmails.set($event)"
              />
            </div>
          </div>

          <!-- Interne Lieferung -->
          <div class="p-4 border border-base-300 rounded-lg">
            <label class="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                class="toggle toggle-primary"
                [ngModel]="isInternalDelivery()"
                (ngModelChange)="isInternalDelivery.set($event); onInternalDeliveryToggle()"
              />
              <div>
                <span class="font-medium">Interne Lieferung</span>
                <p class="text-sm text-base-content/60">Artikel aus einem anderen Lager umbuchen</p>
              </div>
            </label>

            @if (isInternalDelivery()) {
              <div class="mt-3">
                <label class="block text-sm text-base-content/70 mb-1">Quelllager *</label>
                <select
                  class="bm-select w-full"
                  [ngModel]="sourceWarehouseId()"
                  (ngModelChange)="onSourceWarehouseChange($event)"
                >
                  <option [ngValue]="null">-- Lager auswählen --</option>
                  @for (wh of warehouses; track wh.id) {
                    <option [ngValue]="wh.id">{{ wh.label }} ({{ wh.address_city }})</option>
                  }
                </select>
              </div>
              @if (isLoadingStock()) {
                <div class="flex items-center gap-2 text-sm text-base-content/60 mt-2">
                  <span class="loading loading-spinner loading-xs"></span>
                  Lagerbestand wird geladen...
                </div>
              }
            }
          </div>

          <!-- Hinweise -->
          <div>
            <label class="block text-sm text-base-content/70 mb-1">Hinweise für Lageristen</label>
            <textarea
              class="bm-input w-full min-h-[80px]"
              placeholder="Zusätzliche Informationen..."
              [ngModel]="notes()"
              (ngModelChange)="notes.set($event)"
            ></textarea>
          </div>
        </div>
      }

      <!-- Step 2: Artikelpositionen -->
      @if (currentStep() === 2) {
        <div class="space-y-4">
          <!-- Summary from Step 1 -->
          <div class="p-3 bg-base-200 rounded-lg text-sm">
            <div class="flex items-center justify-between mb-2">
              <span class="font-semibold">Zusammenfassung Schritt 1</span>
              <button type="button" class="text-primary text-xs hover:underline" (click)="previousStep()">
                Bearbeiten
              </button>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-2 text-base-content/70">
              <div><strong>Handlung:</strong> {{ getHandlingInstructionLabel() }}</div>
              <div><strong>Projekt:</strong> {{ getProjectName() }}</div>
              <div><strong>Kunde:</strong> {{ getCustomerName() }}</div>
              @if (orderNr()) {
                <div><strong>Auftrags-Nr.:</strong> {{ orderNr() }}</div>
              }
            </div>
          </div>

          <!-- Warning if items missing templates -->
          @if (itemsWithoutTemplateCount() > 0) {
            <div class="p-3 bg-error/10 border border-error/30 rounded-lg flex items-center gap-3">
              <i class="fa fa-exclamation-triangle text-error"></i>
              <span class="text-sm">
                <strong>{{ itemsWithoutTemplateCount() }} Position(en)</strong> ohne Artikelvorlage.
                Bitte allen Positionen eine Vorlage zuordnen.
              </span>
            </div>
          }

          <!-- Warning if items missing storage bins -->
          @if (itemsWithoutStorageBinCount() > 0) {
            <div class="p-3 bg-error/10 border border-error/30 rounded-lg flex items-center gap-3">
              <i class="fa fa-warehouse text-error"></i>
              <span class="text-sm">
                <strong>{{ itemsWithoutStorageBinCount() }} Position(en)</strong> ohne Lagerplatz.
                Bitte allen Positionen einen Lagerplatz zuordnen.
              </span>
            </div>
          }

          <!-- Warning if items have missing serial numbers -->
          @if (itemsWithMissingSerialNumbers().length > 0) {
            <div class="p-3 bg-warning/10 border border-warning/30 rounded-lg flex items-start gap-3">
              <i class="fa fa-barcode text-warning mt-0.5"></i>
              <div class="text-sm">
                <strong class="text-warning">Seriennummern-Hinweis:</strong>
                <span> Bei {{ itemsWithMissingSerialNumbers().length }} Position(en) fehlen Seriennummern.</span>
                <p class="text-xs text-base-content/60 mt-1">
                  Diese Seriennummern können vom Lager bei der Bestätigung nachgetragen werden.
                </p>
              </div>
            </div>
          }

          <!-- Items List -->
          <div class="space-y-3">
            @for (item of items(); track item.id; let i = $index) {
              <div
                class="p-4 border rounded-lg"
                [class.border-error]="!item.articleTemplateId"
                [class.border-base-300]="item.articleTemplateId"
              >
                <!-- Header: Beschreibung + Artikelvorlage -->
                <div class="flex items-start justify-between gap-4 mb-3">
                  <div class="flex-1 min-w-0">
                    <p class="font-semibold">{{ item.displayDescription }}</p>
                    @if (item.customDescription && item.customDescription !== item.displayDescription) {
                      <p class="text-xs text-base-content/60">Freitext: {{ item.customDescription }}</p>
                    }
                    @if (item.serialNumbersRaw && item.serialNumbersRaw.length > 0) {
                      <div class="flex flex-wrap gap-1 mt-2">
                        @for (sn of item.serialNumbersRaw; track sn) {
                          <span class="badge badge-sm bg-base-200">{{ sn }}</span>
                        }
                      </div>
                    }
                  </div>
                  <!-- ArticleTemplate Selection im Header -->
                  <div class="shrink-0">
                    @if (item.articleTemplateId) {
                      <div class="flex items-center gap-1">
                        <span class="badge badge-success">
                          {{ item.articleTemplateName }}
                        </span>
                        @if (item.articleTemplateSn) {
                          <span class="badge badge-info badge-xs" title="Seriennummern-pflichtig">SN</span>
                        }
                        <button
                          type="button"
                          class="bm-btn bm-btn-xs bm-btn-ghost"
                          (click)="openTemplateModal(i)"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                      </div>
                    } @else {
                      <button
                        type="button"
                        class="bm-btn bm-btn-sm bm-btn-error"
                        (click)="openTemplateModal(i)"
                      >
                        <i class="fa fa-plus mr-1"></i> Vorlage zuordnen
                      </button>
                    }
                  </div>
                </div>

                <!-- SN Warning for this item -->
                @if (item.articleTemplateSn && getMissingSnCount(item) > 0) {
                  <div class="mb-2 px-2 py-1 bg-warning/10 border border-warning/30 rounded text-xs text-warning flex items-center gap-2">
                    <i class="fa fa-barcode"></i>
                    <span>
                      <strong>{{ getMissingSnCount(item) }} SN(s) fehlen</strong> -
                      {{ item.serialNumbersRaw?.length || 0 }} von {{ item.quantityOrdered }} erfasst
                    </span>
                  </div>
                }

                <!-- Quantity + Owner + StorageBin in rows -->
                <div class="flex flex-wrap items-center gap-4">
                  <!-- Quantity (read-only) -->
                  <div class="flex items-center gap-2">
                    <label class="text-sm text-base-content/70">Anzahl:</label>
                    <span class="font-medium">{{ item.quantityOrdered }}</span>
                  </div>

                  <!-- Owner Selection -->
                  <div class="flex items-center gap-2">
                    <label class="text-sm text-base-content/70">Besitzer:</label>
                    <select
                      class="bm-select bm-select-sm w-auto"
                      [ngModel]="item.owner"
                      (ngModelChange)="updateItemOwner(i, $event)"
                    >
                      <option value="BENTOMAX">BENTOMAX</option>
                      <option value="CUSTOMER">CUSTOMER</option>
                    </select>
                  </div>

                  <!-- Storage Bin Selection -->
                  <div class="flex items-center gap-2">
                    <label class="text-sm text-base-content/70">Lagerplatz:</label>
                    @if (item.storageBinId) {
                      <div class="flex items-center gap-1">
                        <span class="badge badge-primary">
                          {{ item.storageBinLabel }}
                        </span>
                        <button
                          type="button"
                          class="bm-btn bm-btn-xs bm-btn-ghost"
                          (click)="openStorageBinModal(i)"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                      </div>
                    } @else {
                      <button
                        type="button"
                        class="bm-btn bm-btn-sm bm-btn-error"
                        (click)="openStorageBinModal(i)"
                      >
                        <i class="fa fa-warehouse mr-1"></i> Zuordnen
                      </button>
                    }
                  </div>
                </div>

                <!-- Lagerbestand-Warnung bei interner Lieferung -->
                @if (isInternalDelivery() && sourceWarehouseId() && item.articleTemplateId) {
                  @let stock = getSourceWarehouseStockForTemplate(item.articleTemplateId);
                  @if (stock < item.quantityOrdered) {
                    <div class="bm-alert bm-alert-warning bm-alert-soft text-sm mt-2">
                      <i class="fa fa-exclamation-triangle"></i>
                      <span>
                        Nur {{ stock }} im Quelllager verfügbar.
                        {{ item.quantityOrdered - stock }} bleiben offen und gehen als
                        Klärfall zurück ins Büro.
                      </span>
                    </div>
                  } @else {
                    <div class="text-success text-sm flex items-center gap-1 mt-2">
                      <i class="fa fa-check"></i>
                      {{ stock }} im Quelllager verfügbar
                    </div>
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-between p-4 border-t border-base-300 bg-base-200/50">
      <div>
        @if (currentStep() > 1) {
          <button type="button" class="btn btn-ghost" (click)="previousStep()">
            <i class="fa fa-arrow-left mr-2"></i> Zurück
          </button>
        }
      </div>
      <div class="flex items-center gap-3">
        <button type="button" class="btn btn-ghost" (click)="close()">Abbrechen</button>
        @if (currentStep() < totalSteps) {
          <button
            type="button"
            class="bm-btn bm-btn-primary"
            [disabled]="!isStep1Valid()"
            (click)="nextStep()"
          >
            Weiter <i class="fa fa-arrow-right ml-2"></i>
          </button>
        } @else {
          <button
            type="button"
            class="btn btn-success"
            [disabled]="!canApprove()"
            (click)="submit()"
          >
            @if (isSubmitting()) {
              <span class="loading loading-spinner loading-sm mr-2"></span>
              Wird freigegeben...
            } @else {
              <i class="fa fa-check mr-2"></i> Freigeben
            }
          </button>
        }
      </div>
    </div>
  </div>
</div>

<!-- Template Selection Modal -->
@if (showTemplateModal()) {
  <app-article-template-picker
    [project]="projectId() ? { id: projectId()!, name: getProjectName() } : null"
    [customer]="customerId() ? { id: customerId()!, name: getCustomerName() } : null"
    [initialSearchQuery]="getTemplateModalInitialSearch()"
    [externalTemplates]="articleTemplates"
    (templateSelected)="onTemplatePickerSelected($event)"
    (templatesReloaded)="onPickerTemplatesReloaded($event)"
    (closed)="closeTemplateModal()"
  />
}

<!-- Admin User Selection Modal -->
@if (showAdminUserModal()) {
  <div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" (click)="closeAdminUserModal()">
    <div
      class="bg-base-100 rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col m-4"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between p-4 border-b border-base-300">
        <h3 class="text-lg font-bold">Benutzer auswählen</h3>
        <button class="btn btn-sm btn-ghost btn-circle" (click)="closeAdminUserModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4">
        @if (adminUsers.length === 0) {
          <p class="text-center text-base-content/60 py-8">
            <span class="loading loading-spinner loading-sm mr-2"></span>
            Lade Benutzer...
          </p>
        } @else {
          <div class="space-y-2">
            @for (user of adminUsers; track user.id) {
              <label class="flex items-center gap-3 p-2 hover:bg-base-200 rounded cursor-pointer">
                <input
                  type="checkbox"
                  class="checkbox checkbox-sm"
                  [checked]="user.selected"
                  (change)="toggleAdminUser(user)"
                />
                <div>
                  <p class="font-medium">{{ user.name }}</p>
                  <p class="text-xs text-base-content/60">{{ user.email }}</p>
                </div>
              </label>
            }
          </div>
        }
      </div>

      <div class="flex justify-end gap-3 p-4 border-t border-base-300">
        <button type="button" class="bm-btn bm-btn-ghost" (click)="closeAdminUserModal()">Abbrechen</button>
        <button type="button" class="bm-btn bm-btn-primary" (click)="applyAdminUserSelection()">Übernehmen</button>
      </div>
    </div>
  </div>
}

<!-- Storage Bin Selection Modal -->
@if (showStorageBinModal()) {
  <div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" (click)="closeStorageBinModal()">
    <div
      class="bg-base-100 rounded-lg shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col m-4"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between p-4 border-b border-base-300">
        <h3 class="text-lg font-bold">Lagerplatz auswählen</h3>
        <button class="btn btn-sm btn-ghost btn-circle" (click)="closeStorageBinModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="p-4 border-b border-base-300">
        <input
          type="text"
          class="bm-input w-full"
          placeholder="Lagerplatz suchen..."
          [ngModel]="storageBinSearchQuery()"
          (ngModelChange)="onStorageBinSearchChange($event)"
        />
      </div>

      <div class="flex-1 overflow-y-auto p-4">
        @if (storageBins.length === 0) {
          <p class="text-center text-base-content/60 py-8">
            <span class="loading loading-spinner loading-sm mr-2"></span>
            Lade Lagerplätze...
          </p>
        } @else if (filteredStorageBins().length === 0) {
          <p class="text-center text-base-content/60 py-8">Keine Lagerplätze gefunden</p>
        } @else {
          <div class="grid grid-cols-2 md:grid-cols-3 gap-2">
            @for (bin of filteredStorageBins(); track bin.id) {
              <button
                type="button"
                class="p-3 border border-base-300 rounded-lg hover:bg-base-200 transition-colors text-left"
                (click)="selectStorageBin(bin)"
              >
                <p class="font-medium">{{ bin.name }}</p>
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
